<mat-card appearance="outlined">
  <mat-card-title *ngIf="!dialogYesNo.dontShowTitle" [innerText]="applyStrings( dialogYesNo.title | translate, (dialogYesNo.titleReplace || []) )"></mat-card-title>
  <mat-card-content [ngClass]="{'no-title': dialogYesNo.dontShowTitle}">
    <span class="text" [innerText] = "applyStrings( dialogYesNo.question | translate, ( dialogYesNo.questionReplace || [] ) ) "></span>
    <span class="enumeration" *ngIf="dialogYesNo.enumeration">
      <ul>
        <li *ngFor="let elem of dialogYesNo.enumeration" class="form-row">
          {{elem}}
        </li>
      </ul>
    </span>

  </mat-card-content>
  <mat-dialog-actions>
	  <button (click)="closeDialog(true)" [innerText]="dialogYesNo.confirm | translate" class="confirm" mat-stroked-button></button>
    <button mat-stroked-button class="cancel" (click)="closeDialog(false)" *ngIf="!dialogYesNo.dontShowCancel" [innerText] = "dialogYesNo.cancel | translate"></button>
  </mat-dialog-actions>
</mat-card>
